import { XMarkIcon } from '@heroicons/react/24/solid'
import { ReactElement } from 'react'

export function ItemsTitle({
  title,
  subtitle,
  items,
  onClose,
}: {
  title: string
  subtitle?: string
  items: number
  onClose: () => void
}): ReactElement {
  return (
    <div className="mb-6 flex h-20 shrink-0 items-center justify-between border-b border-default py-6 pl-3 pr-6">
      <div className="flex gap-x-3">
        <div>
          <div className="text-heading-md capitalize leading-6 text-strong">{title}</div>
          {!!subtitle && <div className="text-heading-xs capitalize text-subtle">{subtitle}</div>}
        </div>
        <div className="border-default ml-3 flex h-6 items-center justify-center rounded border-[0.5px] bg-gray-minimal px-1.5 py-0.5 text-label-xs text-gray-strong">{`${items.toLocaleString(
          `en-US`,
        )} ${items !== 1 ? `items` : `item`}`}</div>
      </div>
      <button aria-label="close" id="close-modal-btn" onClick={onClose} type="button">
        <XMarkIcon className="h-5 w-5 cursor-pointer" />
      </button>
    </div>
  )
}
